import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';

var StyledTab = styled(Tab)({
  margin: 0,
  minHeight: 0,
  color: "#696C80",
  "&:hover": { opacity: 1 },
  backgroundColor: "#EBECF2",
  textTransform: "uppercase",
  "&.MuiTab-root": { maxHeight: 35 },
  "&.Mui-focusVisible": { backgroundColor: "#d1eaff" },
  "&.Mui-selected": { color: "black", backgroundColor: "white" }
});
var StyledTab_default = StyledTab;
var StyledTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#1890ff",
    display: "none"
  },
  display: "inline-flex",
  backgroundColor: "#EBECF2",
  minHeight: 0,
  height: "auto",
  padding: 2,
  borderRadius: 4,
  overflow: "hidden"
});
var StyledTabs_default = StyledTabs;

export { StyledTab_default, StyledTabs_default };
//# sourceMappingURL=chunk-NOJ74DUO.js.map
//# sourceMappingURL=chunk-NOJ74DUO.js.map